import type { CardVideoMiniPlayerMeta } from "./cardVideoMiniPlayerStore";

export function buildCardVideoMiniPlayerMeta(options: {
  title?: string;
  description?: string;
  subtitle?: string;
  mediaUrl?: string;
  embedUrl?: string;
  posterUrl?: string;
}): CardVideoMiniPlayerMeta {
  return {
    title: options.title,
    subtitle: options.subtitle || options.description,
    mediaUrl: options.mediaUrl,
    embedUrl: options.embedUrl || options.mediaUrl,
    posterUrl: options.posterUrl,
  };
}
